const BILLING_REQUIRED_PATH_RE = /^\/\d+\/billing-required\/?$/;
const BILLING_SETTINGS_PATH_RE = /^\/\d+\/settings\/billing(\/.*)?$/;

/**
 * Returns the billing-required route path for the given org.
 */
export function getBillingRequiredPath(orgId: number | string): string {
  return `/${orgId}/billing-required`;
}

/**
 * Returns true if pathname matches the billing-required route for any org.
 */
export function isBillingRequiredPath(pathname: string): boolean {
  return BILLING_REQUIRED_PATH_RE.test(pathname);
}

/**
 * Returns true if pathname is exempt from billing enforcement (billing-required page
 * or billing settings, including nested sub-paths).
 */
export function isBillingExemptPath(pathname: string): boolean {
  return (
    isBillingRequiredPath(pathname) || BILLING_SETTINGS_PATH_RE.test(pathname)
  );
}
